import { styled } from '@mui/material/styles'

export const IconWrapper = styled('div', {
  name: 'IconWrapper',
  slot: 'Root',
  skipSx: true,
  skipVariantsResolver: true,
})(({ theme }) => ({
  '> svg': {
    maxWidth: '40px',
    maxHeight: '38px',
  },
  paddingTop: theme.spacing(1),
  marginRight: theme.spacing(1),
  paddingBottom: theme.spacing(1),
}))
